import i18n from 'i18n-iso-countries'
import ar from 'i18n-iso-countries/langs/ar.json'
import en from 'i18n-iso-countries/langs/en.json'

// Register languages
i18n.registerLocale(en)
i18n.registerLocale(ar)

/**
 * Convert a 2-letter country code to its translated name
 * @param countryCode - 2-letter ISO country code (e.g., 'US', 'KW')
 * @param locale - 2-letter locale code (e.g., 'en', 'ar')
 * @returns Translated country name or the original code if not found
 */
export function getCountryName(countryCode: string | null | undefined, locale: string = 'en'): string {
  if (!countryCode) return ''

  // Normalize locale to 2-letter code (e.g., 'en-US' -> 'en')
  const normalizedLocale = locale.split('-')[0].toLowerCase()

  const upperCode = countryCode.toUpperCase()
  const names = i18n.getNames(normalizedLocale)

  return names[upperCode] || countryCode
}

/**
 * Get all countries as an object with code as key and translated name as value
 * @param locale - 2-letter locale code (e.g., 'en', 'ar')
 * @returns Object with country codes as keys and translated names as values
 */
export function getAllCountries(locale: string = 'en'): Record<string, string> {
  // Normalize locale to 2-letter code (e.g., 'en-US' -> 'en')
  const normalizedLocale = locale.split('-')[0].toLowerCase()
  return i18n.getNames(normalizedLocale) || i18n.getNames('en')
}

/**
 * Get all countries as an array of { value, label } objects for dropdowns
 * @param locale - 2-letter locale code (e.g., 'en', 'ar')
 * @returns Array of country objects for select inputs
 */
export function getCountryOptions(locale: string = 'en'): Array<{ value: string; label: string }> {
  // Normalize locale to 2-letter code (e.g., 'en-US' -> 'en')
  const normalizedLocale = locale.split('-')[0].toLowerCase()
  const countryNames = i18n.getNames(normalizedLocale) || i18n.getNames('en')
  return Object.entries(countryNames).map(([code, name]) => ({
    value: code,
    label: name,
  }))
}
